<template>
  <MonitorWrapper>
    <div class="gd-612-container">
      <template v-if="empty">
        <div class="hint">{{ isHisDetail ? '暂无数据' : '数据加载中...' }}</div>
      </template>
      <template v-else>
        <status-bar v-bind="status"></status-bar>
        <chart-wrap ref="chartWrap" :datas="charts"></chart-wrap>
      </template>
    </div>
  </MonitorWrapper>
</template>

<script>
import StatusBar from './components/status-bar.vue';
import ChartWrap from './components/wrap.vue';
import singleDeviceMixin from '@/mixins/singleDeviceMixin';
import { isObject } from '@/utils/is';

export default {
  name: 'GD612',
  mixins: [singleDeviceMixin],
  components: {
    StatusBar,
    ChartWrap
  },
  provide() {
    return {
      time: this.time
    };
  },
  data() {
    return {
      status: {
        alarmStatus: 0,
        runState: 0,
        tumble: 0,
        humidity: 0,
        temperature: 0
      },
      charts: [],
      time: {},
      empty: false
    };
  },
  methods: {
    getDetail() {
      this.getHistoryDetailData(this.eventId)
        .then(res => {
          if (!isObject(res) || !isObject(res.data)) return;
          const { deviceData, deviceDatas } = res.data;
          if (!Array.isArray(deviceDatas)) return;
          this.setData(deviceData);
          let mod = null;
          const list = deviceDatas
            .map(e => {
              mod = this.getGD612Mod(e);
              if (!mod) return;
              return { sensors: mod.sensors, beginTime: e.beginTime };
            })
            .filter(e => isObject(e));
          this.$refs.chartWrap.setData(list, this.getGD612Mod(deviceData));
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    getGD612Mod(res) {
      if (!res || !res.mods || !res.mods.gd612Mod) return null;
      return res.mods.gd612Mod;
    },
    setData(res) {
      try {
        const { status, charts } = this;
        const { runstate, state, mods, beginTime } = res;
        const { gd612Mod } = mods;
        if (!gd612Mod || !gd612Mod.sensors) return;
        this.time.begin = beginTime;
        Object.assign(status, {
          runState: runstate,
          alarmStatus: state,
          tumble: gd612Mod.tumble,
          humidity: gd612Mod.humidity,
          temperature: gd612Mod.temp
        });
        charts.splice(0, Infinity, ...gd612Mod.sensors);
        this.empty = false;
      } catch (err) {
        console.error('[GD606][MONITRO][update error]', err);
      }
    },
    updateData(res) {
      if (!res || res.sn !== this.sn) return;
      if (!this.isHisDetail) this.setData(res);
    }
  },
  mounted() {
    if (this.isHisDetail) {
      this.$nextTick(() => {
        this.getDetail();
      });
    }
  }
};
</script>

<style lang="scss">
.gd-612-container {
  width: 100%;
  height: 100%;

  --status-bar-mt: 15px;
  --status-bar-height: 50px;
  --status-bar-fs: 18px;
  --chart-wrap-mt: 15px;

  @media screen and (max-width: 900px) {
    --status-bar-mt: 5px;
    --status-bar-height: 38px;
    --status-bar-fs: 12px;
    --chart-wrap-mt: 5px;
  }

  span {
    @include state-textstyle;
  }
  .hint {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .common-border2 {
    border: 1px solid rgb(96, 118, 173);
  }
  .common-border {
    height: 100%;
    padding: 2px;
    background-image: url('~@/assets/image/lt.png'), url('~@/assets/image/rt.png'),
      url('~@/assets/image/lb.png'), url('~@/assets/image/rb.png'),
      url('~@/assets/image/linelight.png');
    background-repeat: no-repeat, no-repeat, no-repeat, no-repeat, no-repeat;
    background-position: top left, top right, bottom left, bottom right, center -5px;
    .comp3-content {
      height: 100%;
      box-sizing: border-box;
    }
  }
}
</style>
